import { render, staticRenderFns } from "./FlamePreloader.vue?vue&type=template&id=98492654&scoped=true&"
import script from "./FlamePreloader.vue?vue&type=script&lang=js&"
export * from "./FlamePreloader.vue?vue&type=script&lang=js&"
import style0 from "./FlamePreloader.vue?vue&type=style&index=0&id=98492654&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98492654",
  null
  
)

export default component.exports